import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ArtLab from "./ArtLab";
import ContactSectionBinder from "./ContactSectionBinder";
import PreviewFolder from "./PreviewFolder";

function TopNavbar() {
  return (
    <Navbar bg="none" expand="md" fixed="top" className="pt-3 pb-3 mx-5 mb-3 border-bottom"
                 style={{
                      backgroundColor: '#ffffffff',
                    }}            
    
    >

      <Container fluid>
        <Navbar.Brand as={Link} to="/"
                className="px-3"
                 style={{
                      fontSize: '1.8rem',
                      lineHeight: '1.5',
                      color: '#efeeeaff',
                      backgroundColor:'#232323ff',
                    }}        
        
        ><b>ArtLab.</b></Navbar.Brand>
        <Navbar.Toggle aria-controls="artlab-nav" />
        <Navbar.Collapse id="artlab-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/artlab">Home</Nav.Link>
            <Nav.Link as={Link} to="/contact">About Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    
  );
}

function Contact() {
  return <ContactSectionBinder />;
}

function ArtlabApp() {
  return (
    <Router>
      <TopNavbar />
      <Container fluid className="px-5 mt-4 pt-4 pb-4"></Container>

      <Container fluid className="px-5 mt-4 pt-4">
        <Routes>
          <Route path="/__preview/:dir" element={<PreviewFolder />} />
          <Route path="/" element={<ArtLab content_url="/landers/artlab.json" />} />
          <Route path="/artlab" element={<ArtLab content_url="/landers/artlab.json" />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Container>
    </Router>
  );
}

export default ArtlabApp;
